export enum CaseActionStatusId {
  Open = 1,
  Draft = 2,
  PendingReview = 3,
  PendingIniReview = 4, // Not sure what this is, but seeing it in the backend as well.
  ReviewCompletion = 5,
  Accepted = 6,
  Closed = 7,
  Rejected = 8,
  PendingPWN = 9,
  Cancelled = 10,
  ScheduleSHM = 11,
  SHMScheduled = 12,
  GenEdScheduled = 13,
  PendingCBSTReview = 14,
  Approved = 15,
  Logged = 20,
  Pending = 21,
  PendingInitialReview = 22,
  SHPSent = 23,
  Finalized = 24,
  Schedule = 25,
  ReSchedule = 26,
  NotStarted = 27,
  Scheduled = 28,
  Sent = 29,
  Received = 30,
  Eligible = 31,
  NotEligible = 32,
  PendingApproval = 35,
  AssessmentRejected = 36,
  ExtensionRejected = 37,
  ExtensionApproved = 38,
  Completed = 39,
  Requested = 40,
  STACSubmitted = 41,
  STACApproved = 42,
  NotSpecified = 999,
  PendingScheduling = 44,
  AttemptedPlacement = 45,
  //PendingOSHReview = 47,
  //Disapproved = 48,
  //MoreInformationNeeded = 49,
  AwaitingProviderAssignment = 67,
  AwaitingContractAgency = 75,
  RSA_IA_P4Process = 53,
  AwaitingServiceConfirmation = 54,
  Receiving = 55,
  AssistanceNotRequested = 56,
  RejectedByProvider = 60,
  TerminatedWithoutFirstAttend = 61,
  TerminatedNeverServed = 62,
  TerminatedNeverAssigned = 63,
  Terminated = 64,
  Pending5SchoolDayNotification = 65,
  PendingTermination = 66,
  AwaitingLocationProvider = 51,
  RSARevoked = 68,
  IARevoked = 69,
  P4Revoked = 70,
  ContractAssistanceRequested = 71,
  ContractAgencyTimeout = 72,
  PrimaryAgencyDoesNotExist = 73,
  WithdrawnFromContractAgency = 74,
  AwaitingContractAssistance = 52,
  AwaitingContractAgencyProvider = 76,
  OutreachByDeadline = 77,
  AwaitingLocationProviderConfirmation = 78,
  Created = 79,
  Read = 80,
  AwaitingFirstAttend = 81,
  Assigned = 85,

  PendingOSHReview = 82,
  MoreInformationNeeded = 83,
  Disapproved = 84,
  PendingAssignment = 46,
  //PendingSchedule = 47,
  AwaitingBillingualProvider = 86,
  UnAssigned = 87,
  ContractAgencyRejected = 88,
  WithdrawnfromContractAgency = 89,
  PendingContractAgencyResponses = 90,
  PendingContractAgencyIndependentAgencyResponses = 91,
  ReadytoReward = 92,

  Withdraw = 99,
  Decline = 100,
  ReadyToAward = 101,
  Awarded = 102,
  OBDInprogress = 103,

  RSAIssuedAwaitingIndependentProvider = 104,
  P4IssuedAwaitingIndependentSETSSProvider = 105,
  IAIssuedAwaitingIndependentProvider = 106,
  //Scheduled=107,
  AAIssued = 108,

  RSAProviderDisapprovedSYSTEM = 109,
  RSAProviderDisapprovedUSER = 110,
  P4ProviderDisapprovedSYSTEM = 111,
  P4ProviderDisapprovedUSER = 112,
  RSAApproved = 113,
  P4Approved = 114,
  IAApproved = 115,
  AWaitingSETSSAuth = 116,
  NoResponseReceived = 117,

  ParitiallyAssigned = 118,
  LastEncountered = 119,
  PendingCaseloadAssignmentConfirmation = 121,
  PendingATReferral = 122,
  ATReferralPendingReview = 123,
  ATReferralRejected = 124,
  ATReferralMoreInformationNeeded,
  AwaitingRSA = 126,
  AwaitingIA = 127,
  AwaitingConsentAcknowledgement = 128,
  AwaitingIndependentProviderConfirmation = 129,
  AwaitingIndependentSETSSTeacherConfirmation = 130,
  ReasonForDelayNeeded = 131
}
